import { DragOverlay } from "@dnd-kit/core";
import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import { FC } from "react";
import { createPortal } from "react-dom";
import { useRecoilValue } from "recoil";

import {
  DragTypeEnum,
  getStationComposedId,
  ridesDraggingDataAtom,
  RideStationPanelMode,
} from "@ryde/shared";

import { RideStation } from "./ride-station";

export const RideStationDragOverlay: FC = () => {
  const rideDraggingData = useRecoilValue(ridesDraggingDataAtom);
  const { type: dragType, payload: props } = rideDraggingData;
  return (
    dragType === DragTypeEnum.STATION &&
    createPortal(
      <DragOverlay
        dropAnimation={null}
        modifiers={[restrictToVerticalAxis, restrictToParentElement]}
      >
        <RideStation
          key={getStationComposedId(props.station)}
          station={props.station}
          rideDto={props.rideDto}
          isLastStation={false}
          isFirstStation={false}
          index={props.index}
          isDragClone={true}
          mode={RideStationPanelMode.DRAG_OVERLAY}
        />
      </DragOverlay>,
      document.body,
    )
  );
};
